// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeadlineDesc_wrapper__3K8iG"};